(() => {
  function init(root) {
    if (!root || root.dataset.exReady) return;
    root.dataset.exReady = 'true';
    const search = root.querySelector('#ex-search');
    const cards = [...root.querySelectorAll('[data-ex-record]')];
    const filters = [...root.querySelectorAll('[data-ex-filter]')];
    const count = root.querySelector('[data-ex-count]');
    const empty = root.querySelector('[data-ex-empty]');
    let category = 'All';
    const noun = count.textContent.replace(/^\d+\s*/, '');
    function update() {
      const words = search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let shown = 0;
      cards.forEach(card => {
        const match = (category === 'All' || card.dataset.category.split(' ').includes(category)) && words.every(word => card.dataset.search.toLocaleLowerCase().includes(word));
        card.hidden = !match;
        if (match) shown++;
      });
      count.textContent = `${shown} / ${cards.length} ${noun}`;
      empty.hidden = shown !== 0;
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.exFilter === category)));
    }
    search.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.exFilter; update(); }));
    root.querySelector('[data-ex-reset]').addEventListener('click', () => { category = 'All'; search.value = ''; update(); search.focus(); });

    const wholeSearch = root.querySelector('#ex-whole-search');
    const wholeResults = root.querySelector('[data-ex-whole-results]');
    const wholeStatus = root.querySelector('[data-ex-whole-status]');
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const units = '.ex-world,.ex-wide-note,.ex-glossary,.ex-people-intro,.ex-table-wrap,.ex-record,.ex-essay,.ex-critical-note,.ex-chronology>article,.ex-workshop-grid>article,.ex-costume-grid>article,.ex-production,.ex-document-note>div,.ex-object-grid>article,.ex-conservation,.ex-prop-grid>article,.ex-campaign,.ex-reception-grid>article,.ex-forensics>article,.ex-release,.ex-edition-grid>article,.ex-source-record,.ex-method,.ex-maker-map,.ex-reading-threads article,.cm-capsule,.ex-hero,.ex-section-head';
    const grouped = new Map();
    root.querySelectorAll('p,dt,dd,th,td,caption,figcaption,h2,h3,h4').forEach(node => {
      if (node.closest('.ex-discovery,.ex-nav,dialog')) return;
      const target = node.closest(units) || node;
      if (!grouped.has(target)) grouped.set(target, []);
      grouped.get(target).push(node.textContent.trim());
    });
    const entries = [...grouped].map(([target, parts], index) => {
      const heading = target.querySelector('h2,h3,h4') || (target.matches('h2,h3,h4') ? target : null);
      const title = heading?.textContent.trim() || target.querySelector('summary')?.textContent.replace(/\s*\+$/, '').trim() || parts[0].slice(0,100);
      if (!target.id) {
        const base = 'ex-index-' + normalize(title).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0,70);
        target.id = document.getElementById(base) ? base + '-' + index : base;
      }
      let context = target.closest('.ex-source-record') ? 'Source record' : '';
      if (!context) {
        let section = target;
        while (section && section !== root && !context) {
          for (let sibling = section.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
            if (sibling.matches('.ex-section-head')) { context = sibling.querySelector('h2')?.textContent.trim(); break; }
          }
          section = section.parentElement;
        }
      }
      const text = parts.join(' ');
      return { target, title, context: context || 'Dossier', text, normalized: normalize(title + ' ' + text) };
    });
    function openTarget(target) {
      if (!target) return;
      if (target.closest('[data-ex-record]')?.hidden) { category = 'All'; search.value = ''; update(); }
      for (let ancestor = target; ancestor && ancestor !== root; ancestor = ancestor.parentElement) {
        if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      }
      target.querySelector('details')?.setAttribute('open', '');
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    function wholeUpdate() {
      const query = wholeSearch.value.trim();
      const words = normalize(query).split(/\s+/).filter(Boolean);
      const matches = words.length ? entries.filter(entry => words.every(word => entry.normalized.includes(word))) : [];
      wholeResults.replaceChildren();
      wholeResults.hidden = !words.length || !matches.length;
      wholeStatus.textContent = (words.length ? (matches.length ? wholeStatus.dataset.matches : wholeStatus.dataset.empty) : wholeStatus.dataset.idle).replace('{count}', matches.length).replace('{total}', entries.length);
      matches.forEach(entry => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + entry.target.id;
        const title = document.createElement('strong'); title.textContent = entry.title;
        const context = document.createElement('span'); context.className = 'ex-result-context'; context.textContent = entry.context;
        const snippet = document.createElement('span'); snippet.className = 'ex-result-snippet';
        const position = Math.max(0, normalize(entry.text).indexOf(words[0]) - 65);
        snippet.textContent = (position ? '…' : '') + entry.text.slice(position, position + 220) + (entry.text.length > position + 220 ? '…' : '');
        link.append(context, title, snippet);
        link.addEventListener('click', event => { event.preventDefault(); history.pushState(null, '', link.hash); openTarget(entry.target); });
        item.append(link); wholeResults.append(item);
      });
    }
    if (wholeSearch) {
      wholeSearch.addEventListener('input', wholeUpdate);
      root.querySelector('[data-ex-whole-form]').addEventListener('submit', event => { event.preventDefault(); wholeResults.querySelector('a')?.click(); });
      function clearWhole() { wholeSearch.value = ''; wholeUpdate(); wholeSearch.focus(); }
      root.querySelector('[data-ex-whole-clear]').addEventListener('click', clearWhole);
      wholeSearch.addEventListener('keydown', event => { if (event.key === 'Escape') clearWhole(); });
      wholeUpdate();
    }
    const navTrack = root.querySelector('[data-ex-nav-track]');
    if (navTrack) {
      const prev = root.querySelector('[data-ex-nav-prev]');
      const next = root.querySelector('[data-ex-nav-next]');
      const navLinks = [...navTrack.querySelectorAll('a')];
      function navState() { prev.disabled = navTrack.scrollLeft < 2; next.disabled = navTrack.scrollLeft + navTrack.clientWidth >= navTrack.scrollWidth - 2; }
      function moveNav(direction) { navTrack.scrollBy({left:direction * navTrack.clientWidth * .75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }
      prev.addEventListener('click', () => moveNav(-1)); next.addEventListener('click', () => moveNav(1));
      navTrack.addEventListener('scroll', navState, {passive:true});
      window.addEventListener('resize', navState);
      navLinks.forEach((link, index) => {
        link.addEventListener('focus', () => link.scrollIntoView({block:'nearest',inline:'center'}));
        link.addEventListener('keydown', event => {
          let destination;
          if (event.key === 'ArrowRight') destination = Math.min(index+1,navLinks.length-1);
          if (event.key === 'ArrowLeft') destination = Math.max(index-1,0);
          if (event.key === 'Home') destination = 0;
          if (event.key === 'End') destination = navLinks.length-1;
          if (destination !== undefined) { event.preventDefault(); navLinks[destination].focus(); }
        });
      });
      navState();
    }
    const dialog = root.querySelector('.ex-lightbox');
    let opener;
    root.querySelectorAll('[data-ex-zoom]').forEach(link => link.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      opener = link;
      const image = dialog.querySelector('img');
      image.src = link.href;
      image.alt = link.querySelector('img').alt;
      dialog.querySelector('p').textContent = link.closest('figure').querySelector('figcaption')?.textContent || image.alt;
      dialog.showModal();
    }));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { opener?.focus(); });
    function revealAnchor() {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id.startsWith('ex-')) return;
      const target = document.getElementById(id);
      if (target) { for (let ancestor = target; ancestor && ancestor !== root; ancestor = ancestor.parentElement) { if (ancestor.tagName === 'DETAILS') ancestor.open = true; } } 
    }
    root.addEventListener('click', event => { const a = event.target.closest('a[href^="#ex-"]'); if (a) { const target = document.getElementById(a.hash.slice(1)); if (target?.tagName === 'DETAILS') target.open = true; } });
    window.addEventListener('hashchange', revealAnchor);
    revealAnchor();
  }
  document.querySelectorAll('.ex-dossier').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.ex-dossier')));
})();
